(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/vikinglotto/components/play/views/system-row-container.js') >= 0) return;  svs.modules.push('/modules/vikinglotto/components/play/views/system-row-container.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.vikinglotto=_svs.vikinglotto||{};
_svs.vikinglotto.components=_svs.vikinglotto.components||{};
_svs.vikinglotto.components.play=_svs.vikinglotto.components.play||{};
_svs.vikinglotto.components.play.templates=_svs.vikinglotto.components.play.templates||{};
svs.vikinglotto.components.play.templates.system_row_container = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id='boardContainerRegion' class='col-xs-12 col-sm-10 col-sm-offset-1 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4 padding-top-2'></div>\n<div id='systemSummaryRegion' class='col-xs-12 col-sm-8 col-sm-offset-2 col-md-4 col-md-offset-4 col-lg-4 col-lg-offset-4'></div>\n";
},"useData":true});
Handlebars.partials['svs-vikinglotto-components-play-system_row_container'] = svs.vikinglotto.components.play.templates.system_row_container;
})(svs, Handlebars);


 })(window);